define('mapa-imoveis-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function () {
    var app = angular.module('mapa.imoveis.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
    app.factory('MapaImoveis', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
        function ($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
            return {

                mapImoveis: function (data) {
                    return $http.get(appRoute.linkTo('mapaImoveis.mapImoveis'), data);
                },

                getImoveisByLocation: function (data) {
                    return $http.post(appRoute.linkTo('mapaImoveis.getImoveisByLocation'), data);
                },

                searchBairros: function (cid_codigo) {
                    return $http.get(appRoute.linkTo('mapaImoveis.searchBairros', { cid_codigo: cid_codigo }));
                },

            }
        }
    ]);
});


